import { getUserInitials } from "@/utils";
import { getReadableTimeDiff, isMeetingActive, isMeetingPast, isMeetingUpcoming } from "@/utils/dates";
import { useUser } from "@clerk/react";
import { Avatar, Card } from "@heroui/react";
import { Dot } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

const MeetingCard = ({ _record, _onResp }) => {
  const navigate = useNavigate();
  const { user } = useUser();

  const activeMeets = _record
    ? isMeetingActive(_record["meeting_date"], _record["start_time"]["set"], (_record["end_time"]["real"] || _record["end_time"]["set"]))
    : false;

  const isUpComingMeets = _record
    ? isMeetingUpcoming(_record["meeting_date"], _record["start_time"]["set"], _record["end_time"]["set"])
    : false;

  const isPastMeets = _record
    ? isMeetingPast(_record["meeting_date"], _record["start_time"]["set"], _record["end_time"]["set"])
    : false;

    console.log(isPastMeets)

  function onCardClick() {
    const userId = user?.id;
    const hostId = _record?.created_by?.user_id;
    const code = _record?.short_code;

    if (userId !== hostId) return navigate(`/meetings/view/${code}`);
    if (activeMeets) return navigate(`/meetings/join/${code}`);
    if (isUpComingMeets && userId === hostId) return navigate(`/meetings/edit/${code}`);
    // if (isUpComingMeets) return navigate(`/meetings/edit/${code}`);
    return navigate(`/meetings/view/${code}`);
  }

  if (!_record) return null;

  return (
    <Card className="meeting-card glass-surface bg-white/40 dark:bg-white/11 px-5 py-4.5" onClick={() => onCardClick()}>
      <Card.Header className="flex-row items-center justify-between">
        <div className="flex items-center gap-.5 dark:text-[#FFFFFF91] text-[#1E1E1E91]">
          <small className="font-medium">
            {_record["start_time"]["set"]} – {isPastMeets ? (_record["end_time"]["real"] || _record["end_time"]["set"]) : _record["end_time"]["set"]}
          </small>

          <Dot />

          <small className="text-xs">
            {getReadableTimeDiff(_record["start_time"]["set"], isPastMeets? (_record["end_time"]["real"] || _record["end_time"]["set"]) : _record["end_time"]["set"], "short")}
          </small>
        </div>

        {activeMeets && (
          <div className="flex items-center text-danger">
            <Dot size={16} />

            <span className="text-[10px] uppercase font-semibold">Live</span>
          </div>
        )}
      </Card.Header>

      <Card.Content>
        <div className="flex gap-2 items-center">
          <div className="w-[3px] bg-accent dark:bg-[#EBEBEB] min-h-6 rounded-full" />
          <span className="font-semibold text-xl">{_record?.title || "Untitled Meeting"}</span>
        </div>

        <div className="flex gap-[12px]">
          {_record?.members?.map((member, i) => {
            return (
              <div className="flex items-center relative" key={member.member_id}>
                <Avatar
                  className="meeting-card-avatar relative z-5 shadow-none bg-[#bfc7dd] dark:bg-[#666666] size-[37px]"
                  size="sm"
                >
                  <Avatar.Fallback className="text-xs bg-backdrop/5 uppercase leading-0 h-0 shadow-none border-0 border-background dark:border-white rounded-full text-background dark:text-white">
                    {getUserInitials(member.member_fullname || "Jane Smith")}
                  </Avatar.Fallback>
                </Avatar>

                {i !== _record.members.length - 1 && (
                  <div className="absolute -right-[15px] mt-1 z-0">
                    <img src="/union-2.svg" />
                  </div>
                  // <div className="h-2 w-3 bg-background dark:bg-white" />
                )}
              </div>
            );
          })}
        </div>

        {_record?.members?.length > 0 && (
          <div className="flex mt-2">
            {_record?.members?.map((member, i) => {
              return (
                <div
                  className="flex items-center text-xs tracking-[0.117px] font-normal capitalize dark:text-[#FFFFFF91] text-[#1E1E1E91]"
                  key={member.member_id}
                >
                  {member.member_fullname?.split(" ")[0] || member?.member_email || "Name not provided"}

                  {i !== _record.members?.length - 1 && <Dot size={16} />}
                </div>
              );
            })}
          </div>
        )}
      </Card.Content>
    </Card>
  );
};

export default MeetingCard;
